var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2255_464)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.5,
    width: 44,
    height: 44,
    rx: 12,
    fill: "#B31017",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.85 26.5C26.85 24.7603 28.2603 23.35 30 23.35C31.7397 23.35 33.15 24.7603 33.15 26.5C33.15 28.2397 31.7397 29.65 30 29.65C28.2603 29.65 26.85 28.2397 26.85 26.5ZM30 21.65C27.3214 21.65 25.15 23.8214 25.15 26.5C25.15 29.1786 27.3214 31.35 30 31.35C32.6786 31.35 34.85 29.1786 34.85 26.5C34.85 23.8214 32.6786 21.65 30 21.65ZM24.85 36.4167C24.85 36.0137 25.1787 35.4979 26.2184 35.0388C27.2079 34.6018 28.5842 34.35 30 34.35C31.3957 34.35 32.7709 34.6431 33.7679 35.1047C34.2669 35.3357 34.6328 35.5912 34.863 35.8378C35.0846 36.0753 35.1476 36.2656 35.1499 36.4085C35.1419 36.4301 35.1051 36.4982 34.9627 36.6088C34.7443 36.7786 34.3797 36.9616 33.865 37.1271C32.8446 37.455 31.4363 37.65 30 37.65C28.3015 37.65 26.9034 37.4521 25.9613 37.1316C25.4876 36.9704 25.1811 36.7955 25.0077 36.6425C24.8489 36.5024 24.8499 36.4287 24.85 36.4174L24.85 36.4167ZM35.1519 36.4011C35.1521 36.4011 35.1519 36.403 35.1506 36.4068C35.151 36.403 35.1517 36.4011 35.1519 36.4011ZM30 32.65C28.4158 32.65 26.7921 32.9271 25.5316 33.4837C24.3214 34.0181 23.15 34.9607 23.15 36.4167C23.15 37.0456 23.4676 37.5507 23.8829 37.9173C24.2877 38.2744 24.8249 38.5406 25.4137 38.741C26.5966 39.1435 28.1985 39.35 30 39.35C31.5637 39.35 33.1554 39.1407 34.3851 38.7455C34.9953 38.5494 35.5683 38.2913 36.006 37.951C36.4404 37.6134 36.85 37.1034 36.85 36.4167C36.85 35.7271 36.5361 35.139 36.1058 34.6779C35.6797 34.2213 35.1081 33.8518 34.4821 33.562C33.2291 32.9819 31.6043 32.65 30 32.65ZM36.1539 30.4185C36.1989 29.9512 36.6143 29.6089 37.0815 29.6539C38.2957 29.7709 39.4222 30.0866 40.2734 30.5788C41.0977 31.0555 41.85 31.82 41.85 32.8733C41.85 33.4192 41.6411 33.9171 41.2349 34.3126C40.8519 34.6855 40.3292 34.935 39.7318 35.1043C39.2802 35.2323 38.8103 34.97 38.6822 34.5184C38.5542 34.0667 38.8165 33.5968 39.2682 33.4688C39.7158 33.3419 39.943 33.1978 40.0488 33.0947C40.1314 33.0143 40.15 32.9536 40.15 32.8733C40.15 32.7166 40.0328 32.4034 39.4224 32.0505C38.8389 31.713 37.9653 31.447 36.9185 31.3461C36.4512 31.3011 36.1089 30.8858 36.1539 30.4185ZM38 21.65C37.5306 21.65 37.15 22.0306 37.15 22.5C37.15 22.9695 37.5306 23.35 38 23.35C38.9113 23.35 39.65 24.0888 39.65 25C39.65 25.9113 38.9113 26.65 38 26.65C37.5306 26.65 37.15 27.0306 37.15 27.5C37.15 27.9695 37.5306 28.35 38 28.35C39.8502 28.35 41.35 26.8502 41.35 25C41.35 23.1499 39.8502 21.65 38 21.65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2255_464",
    x: 0,
    y: 0.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2255_464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2255_464",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.34a0e14f94a46ef64e3f501bae9cc5f5.svg";
export { ForwardRef as ReactComponent };